var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[_vm._v("Customer ID")]),_vm._v(" "),_c('kendo-autocomplete',{attrs:{"data-source":_vm.customers,"data-text-field":'ContactName',"template":'#: ContactName # | #: CustomerID #'},on:{"change":function (ev) {this$1.customer = ev.sender.dataItem()}}}),_vm._v(" "),_c('button',{staticClass:"k-button",on:{"click":_vm.onRemove}},[_vm._v("Remove")]),_vm._v(" "),_c('button',{staticClass:"k-button",on:{"click":_vm.onCancel}},[_vm._v("Cancel")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e4ffd50","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RemoveCustomer.vue
// module id = 305
// module chunks = 0